import React from 'react';
import {ActivityIndicator, Platform, Text} from 'react-native';

var LaunchArguments;
if (Platform.OS !== 'web') {
  const ReactNativeLaunchArguments = require('react-native-launch-arguments');
  LaunchArguments = ReactNativeLaunchArguments?.ReactNativeLaunchArguments;
} else {
  LaunchArguments = {
    value: () => {},
  };
}
const CustomActivityIndicator = (props = {}) => {
  const launchArgs = LaunchArguments?.value?.() || {};
  if (launchArgs?.isDetox && Platform.OS == 'android') {
    console.log('hiding activity indicator on detox');
    return <Text style={{color: props?.color || 'black'}}>Loading Mock..</Text>;
  }
  return <ActivityIndicator {...props} />;
};

export default CustomActivityIndicator;
